/**
 * Portal Manta · cor.js
 * Extraído de App.jsx v29.2 modular
 */

export const COR={'Ampliação':{bar:'#D4682A',bg:'#FDF0E8',text:'#8B4A2D'},'Interseções':{bar:'#EF4444',bg:'#FEF2F2',text:'#B91C1C'},'OAE':{bar:'#2057A8',bg:'#EEF3FC',text:'#2057A8'},'Manutenção':{bar:'#756F68',bg:'#F4F3F1',text:'#3D3830'},'Equipamentos':{bar:'#7C3AED',bg:'#F5F3FF',text:'#5B21B6'},'Edificações':{bar:'#DB2777',bg:'#FDF2F8',text:'#9D174D'},'Outros':{bar:'#B07050',bg:'#FDF5F0',text:'#8B4A2D'}};
